import React, { FunctionComponent, useContext, useEffect } from 'react';
import { useValuesFromParameters } from '../../Hook/UseValuesFromParameters';
import { BaseLayout } from '../../Component/BaseLayout/BaseLayout';
import { ShoppingPlannerContext } from '../../Context/ShoppingPlannerContext';
import { ShoppingPlannerInput } from '../../Component/ShoppingPlannerInput/ShoppingPlannerInput';

import './RoomPage.scss';

export const RoomPage: FunctionComponent = () => {
    const { roomLength, setRoomLength, roomWidth, setRoomWidth, roomSqm, setRoomSqm, setLocked } =
        useContext(ShoppingPlannerContext);

    useValuesFromParameters();

    useEffect(() => {
        setLocked((roomLength === '' || roomWidth === '') && roomSqm === '');
    }, [roomLength, roomWidth, roomSqm]);

    return (
        <BaseLayout>
            <div className="shopping-planner-room-page">
                <h2 className="shopping-planner-room-page__headline">Wie groß ist Ihr Raum?</h2>
                <div className="shopping-planner-room-page__fields">
                    <div className="shopping-planner-room-page__dimensions">
                        <ShoppingPlannerInput
                            label="Länge (in m)"
                            value={roomLength}
                            onChange={(event) => setRoomLength(event.target.value)}
                            disabled={roomSqm !== ''}
                            type="number"
                        />
                        <ShoppingPlannerInput
                            label="Breite (in m)"
                            value={roomWidth}
                            onChange={(event) => setRoomWidth(event.target.value)}
                            disabled={roomSqm !== ''}
                            type="number"
                        />
                    </div>
                    <div className="shopping-planner-room-page__divider shopping-planner-room-page__divider">
                        <span>oder</span>
                    </div>
                    <div className="shopping-planner-room-page__sqm">
                        <ShoppingPlannerInput
                            label="Fläche (in m²)"
                            type="number"
                            value={roomSqm ?? ''}
                            disabled={roomWidth !== '' || roomLength !== ''}
                            onChange={(event) => setRoomSqm(event.target.value)}
                        />
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};
